import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { showApiErrorToast } from '@/utils/errors';
import { createLeaveType, leaveTypeQueryKeys } from '../api/leaveTypes.api';
import type { CreateLeaveTypePayload } from '../types/leaveType.types';

export function useCreateLeaveType(onSuccess?: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: CreateLeaveTypePayload) => createLeaveType(payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: leaveTypeQueryKeys.all() });
      toast.success('Leave type created successfully');
      onSuccess?.();
    },
    onError: (error) => {
      showApiErrorToast(error, 'Failed to create leave type');
    },
  });
}
